import { Button, Icon } from '@chakra-ui/react';

import DownloadIcon from '@/assets/icons/ic-download.svg';

export const DownloadLink = ({ children, ...rest }) => {
  return (
    <Button
      as="a"
      target="_blank"
      variant="unstyled"
      leftIcon={<Icon as={DownloadIcon} w="24px" h="24px" color="black" />}
      pl={0}
      color="violet.500"
      display="inline-flex"
      justifyContent="start"
      {...rest}
    >
      {children}
    </Button>
  );
};
